import React from 'react';
import { NavLink } from 'react-router-dom';

const Navigation = () => {
    return (
        <div className='navigation'>
            <ul>
                <NavLink to='/' className={(nav) => (nav.isActive ? 'nav-active' : '')}><li>
                    {/* J'applique une ternaire en utilisant le 'isActive' afin de mettre un style différent en fonction de la condition 'active ou pas' */}
                    Accueil</li>
                </NavLink>
                <NavLink to='/about' className={(nav) => (nav.isActive ? 'nav-active' : '')}><li>
                    About</li>
                </NavLink>
                <NavLink to='/blog' className={(nav) => (nav.isActive ? 'nav-active' : '')}><li>
                    Blog</li>
                </NavLink>


            </ul>
        </div>
    );
};

export default Navigation;